import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { Automation } from 'domain/entity/automation';

export type ReadAutomationsCriteria = {
    templateDashboardId?: string;
};

const readAutomationsApiClient = getArrayApiClient(
    (criteria: ReadAutomationsCriteria) =>
        criteria && criteria.templateDashboardId
            ? `dashboards/automations?templateDashboardId=${criteria.templateDashboardId}`
            : `dashboards/automations`,
    Automation
);

export default readAutomationsApiClient;
